<template lang="pug">
	div(v-if="ready")
		b-modal(id="login-modal" title="Log In" centered no-fade :hide-footer="true" @hidden="closeModal")
			p
				| Enter your e-mail address and password to login. For security, we track login attempts.
			.alert.alert-danger(v-if="generalLoginErrorExist")
				p
					sfc-html-evaluator(:content=`generalLoginErrorMessage`)

			form(v-on:submit.prevent="login")
				.tb
					input.special-hp(id="full-name1" type="text" name="fullName" placeholder="Full Name" ref="fullName" value="")
					label(:class="{'not-empty': !email == '' }")
						sfc-input(ref="emailInput" type="text" :class="{error: userEmailErrorExist}" v-model="email" @input="validLoginForm" id="login-modal-email")
						span.floaty-label
							| Email Address
						.error(v-if="userEmailErrorExist")
							| &nbsp;{{userEmailErrorMessage}}
				.tb
					label(:class="{'not-empty': !password == '' }")
						sfc-input(type="password" :class="{error: userPasswordErrorExist}" v-model="password" @input="validLoginForm" id="login-modal-password")
						span.floaty-label
							| Password
						span.error(v-if="userPasswordErrorExist")
							| &nbsp;{{userPasswordErrorMessage}}
				a.forgot-pw(@click="openForgotPwd")
					| Forgot your Password?
				br
				b-btn.button.sfc-blue(type="submit")
					| LOG IN
				p.text-center
					| Don't have an account?&nbsp;
					a(:href="registerUrl")
						| Sign Up
</template>

<style lang="stylus" scoped>
	.floaty-label
		top 15px
	.special-hp
		display: none

	#login-modal
		a.forgot-pw
			display: block
			text-align: right
		.button.sfc-blue
			width: 100%
			max-width: 300px
			margin: 15px auto
			display: block

</style>

<style lang="stylus">
#login-modal
#forgot-password-modal
	a
		cursor: pointer
		transition-all()
	.modal-dialog
		max-width: 400px
		box-shadow()
		margin: 0 auto
	.alert.alert-danger
		a
			color: #fff
</style>

<script>
	export default {
		data(){
			return {
				ready: true,
				email:"",
				password:"",
				validateLoginOnChange: false,
				generalLoginErrorMessage: "",
				generalLoginErrorExist: false,
				userPasswordErrorExist: false,
				userPasswordErrorMessage: false,
				userEmailErrorMessage: "",
				userEmailErrorExist: false,
				loadingLogin: false
			}
		},

		computed:{
			registerUrl(){
				return `${this.$store.state.config.sfcHost}/subscribe`
			}
		},

		methods:{
			openForgotPwd(){
				this.$root.$emit('bv::show::modal','forgot-password-modal')
			},
			focusEmail(){
				this.$refs.emailInput.focus()
			},
			closeModal(){
				this.email = ""
				this.password = ""
				this.validateLoginOnChange = false
				this.generalLoginErrorMessage = ""
				this.generalLoginErrorExist = false
				this.userPasswordErrorExist = false
				this.userPasswordErrorMessage = false
				this.userEmailErrorMessage = ""
				this.userEmailErrorExist = false
				this.loadingLogin = false
			},
			validLoginForm() {
				this.generalLoginErrorMessage = ''
				this.generalLoginErrorExist = false
				if (this.validateLoginOnChange) {
					if (!this.email || this.email.trim() == "") {
						this.userEmailErrorExist = true
						this.userEmailErrorMessage = 'Required'
					} else {
						this.userEmailErrorExist = false
						this.userEmailErrorMessage = ''
					}

					if (!this.password || this.password.trim() == "") {
						this.userPasswordErrorExist = true
						this.userPasswordErrorMessage = 'Required'
					} else {
						this.userPasswordErrorExist = false
						this.userPasswordErrorMessage = ''
					}

					if (this.userEmailErrorExist || this.userPasswordErrorExist) {
						return false
					}
				}
				return true
			},

			async login(){

				if (this.$refs.fullName && this.$refs.fullName.value && this.$refs.fullName.value != ""){
					const value = this.$refs.fullName.value
					const url = location.href
					const queryHP = `
						mutation {
							add_ip_to_honeypot_list(value: "${value}", url: "${url}")
						}
					`
					try {
						const response = await this.$httpService.graphql(queryHP)
					} catch (e) {
					}
					return
				}

				this.validateLoginOnChange = true
				if (this.validLoginForm() && !this.loadingLogin){
					this.loadingLogin = true
					const url = `${this.$store.state.config.sfcHost}/login/index.php`
					const params = {
						username_email: this.email,
						password: this.password,
						mode: "login",
						via: "ajax",
						from_app: "spa_nuxt",
					}
					const response = await this.$httpService.post(url,params)
					if(!response.success){
						this.generalLoginErrorMessage = `<span>${response.error}</span>`
						this.generalLoginErrorExist = true
					} else {
						
						// Track Heap
						if (heap) {
							heap.addUserProperties({"email": this.email});
						}
					
						let date = new Date()
						date.setTime(date.getTime() + (360 * 24 * 60 * 60))
						let expires = "; expires=" + date.toGMTString()
						document.cookie = encodeURIComponent('sfc_primary') + "=" + encodeURIComponent(response.login_token) + expires + "; domain=savingforcollege.com; path=/ ;"

						// Create email cookie
						date = new Date()
						date.setTime(date.getTime() + (7 * 4 * 24 * 60 * 60))
						expires = "; expires=" + date.toGMTString()
						document.cookie = encodeURIComponent(response.email_cookie.cookie_name) + "=" + encodeURIComponent(response.email_cookie.cookie_value) + expires + "; domain=savingforcollege.com; path=/ ;"

						if(window.location.pathname != "/subscribe/"){
							window.location.reload()
						} else {
							window.location.href = "/"
						}
					}
					this.loadingLogin = false
				}
			},

			validResetPasswordForm(){
				this.generalLoginErrorMessage = ''
				this.generalLoginErrorExist = false

				if(this.validateLoginOnChange){
					if (!this.email || this.email.trim() == ""){
						this.userEmailErrorExist = true
						this.userEmailErrorMessage = 'Required'
					}else{
						this.userEmailErrorExist = false
						this.userEmailErrorMessage = ''
					}

					if (this.userEmailErrorExist){
						return false
					}
				}
				return true
			}
		}

	}
</script>
